import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import MusicToggle from './MusicToggle';
import Confetti from '../animations/Confetti';

interface Props {
  onClose?: () => void;
  onPlayAgain?: () => void;
  leaderboard?: LeaderboardEntry[];
  leaderBoard?: LeaderboardEntry[];
  gameInfo?: GameStatusInfo;
}

const podiumColors = ['#D4A843', '#8B7355', '#CD7F32'];

const SketcherGameOver: React.FC<Props> = ({ onClose, onPlayAgain, leaderboard, leaderBoard, gameInfo }) => {
  const board = leaderboard || leaderBoard || [];
  const handleClose = onClose || onPlayAgain || (() => {});
  const top3 = board.slice(0, 3);
  // Podium display order: 2nd, 1st, 3rd
  const podiumOrder = top3.length >= 3 ? [top3[1], top3[0], top3[2]] : top3;
  const podiumPlaces = top3.length >= 3 ? [2, 1, 3] : top3.map((_, i) => i + 1);

  return (
    <div className="sketcher-over">
      <Confetti active />
      <MusicToggle />
      <button className="sketcher-over__back" onClick={handleClose}>
        <FontAwesomeIcon icon={faArrowLeft} /> Exit
      </button>

      <div className="sketcher-over__content">
        {/* Header */}
        <div className="sketcher-over__header">
          <span className="sketcher-over__trophy">
            <FontAwesomeIcon icon={faTrophy} />
          </span>
          <h1 className="sketcher-over__title">Game Over!</h1>
          <p className="sketcher-over__subtitle">
            {gameInfo?.gameTitle || 'Sketcher Game'} · {gameInfo?.totalRound || 0} Rounds
          </p>
        </div>

        {/* Podium */}
        {top3.length > 0 && (
          <div className="sketcher-over__podium">
            {podiumOrder.map((player, i) => {
              const place = podiumPlaces[i];
              return (
                <div key={player.playerId} className="sketcher-over__podium-col">
                  <span
                    className="sketcher-over__podium-avatar"
                    style={{ background: player.iconColor }}
                  >
                    {player.playerIcon}
                  </span>
                  <span className="sketcher-over__podium-name">{player.playerName}</span>
                  <div
                    className={`sketcher-over__podium-block sketcher-over__podium-block--${place}`}
                    style={{ background: podiumColors[i] }}
                  >
                    <span className="sketcher-over__podium-place">{place}</span>
                    <span className="sketcher-over__podium-score">{player.totalPoints} pts</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Full leaderboard */}
        <div className="sketcher-over__leaderboard">
          <h3 className="sketcher-over__lb-title">Final Scoreboard</h3>
          <div className="sketcher-over__lb-list">
            {board.map((player) => (
              <div key={player.playerId} className="sketcher-over__lb-row">
                <span className="sketcher-over__lb-rank">#{player.rank}</span>
                <span
                  className="sketcher-over__lb-avatar"
                  style={{ background: player.iconColor }}
                >
                  {player.playerIcon}
                </span>
                <div className="sketcher-over__lb-info">
                  <span className="sketcher-over__lb-name">{player.playerName}</span>
                </div>
                <span className="sketcher-over__lb-score">{player.totalPoints} pts</span>
              </div>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="sketcher-over__actions">
          <button className="sketcher-over__btn sketcher-over__btn--primary" onClick={handleClose}>
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default SketcherGameOver;
